import type {Result, UseCase} from 'framework';
import type {SettingsError} from '../../domain/errors';
import type {UserProfile} from '../../domain/user-profile';
import type {SettingsRepository} from '../ports/settings.repository';

export class UpdateAvatar implements UseCase<[File], UserProfile> {
  constructor(private readonly repository: SettingsRepository) {}

  execute(file: File): Promise<Result<UserProfile, SettingsError>> {
    return this.repository.updateAvatar(file);
  }
}
